"use strict";

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  width: 100%;\n  padding: 10px;\n  min-height: 104px;\n  border: 2px solid ", ";\n  border-radius: 5px;\n  &:focus {\n    box-shadow: 0 0 0px 2px ", ";\n    outline: 0;\n  }\n  background-color: ", ";\n  color: ", ";\n\n  &::-webkit-input-placeholder {\n    color: ", ";\n  }\n  &::-moz-placeholder {\n    color: ", ";\n  }\n  &:-ms-input-placeholder {\n    color: ", ";\n  }\n  @media (min-width: ", "px) {\n    width: 535px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.TextArea = styled_components_1.default.textarea(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.bodyStyle;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.formBorder;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.focus;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.background;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.copy;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.placeholder;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.placeholder;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.placeholder;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.grid.breakpoints.md;
});